import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlan: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPlan"><Path d="M21 10H14V7.25H8.81348C7.77942 7.25 7.42521 8.6275 8.33105 9.12598L16.3916 13.5596C18.6569 14.8055 17.7719 18.25 15.1865 18.25H10V21H3V14H10V16.75H15.1865C16.2206 16.75 16.5748 15.3725 15.6689 14.874L7.6084 10.4404C5.34308 9.1945 6.22813 5.75 8.81348 5.75H14V3H21V10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPlan;
